<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>报修记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div class="handle_box">
        <!--查询盒子-->
        <!--<el-input placeholder="警报点" class="handle_input" v-model="GetReportRecordList.params.alarmPointId" style="width: 130px"></el-input>-->
<!--        <el-select placeholder="警报点" class="handle_input" v-model="GetReportRecordList.params.alarmPointId" @click.native="getAlarmPointList"-->
<!--                   filterable clearable style="width: 130px">-->
<!--          <el-option-->
<!--            v-for="item in alarmPointList.result.alarmPointList"-->
<!--            :label="item.pointName" :value="item._id"></el-option>-->
<!--        </el-select>-->
        <el-input class="handle_input" v-model="GetReportRecordList.params.pointName" placeholder="警报点名称"></el-input>
        <!--<el-input placeholder="负责人" class="handle_input" v-model="GetReportRecordList.params.reporterName" style="width: 130px"></el-input>-->
        <el-select placeholder="负责人" class="handle_input" v-model="GetReportRecordList.params.reporterName" @click.native="getUserList"
                   filterable clearable style="width: 130px">
          <el-option
            v-for="item in userList.result.userList"
            :label="item.name"
            :value="item.name"></el-option>
        </el-select>
        <el-date-picker type="date" placeholder="开始日期" style="width: 150px; margin-left: 20px;" v-model="GetReportRecordList.params.startTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>&nbsp;-
        <el-date-picker type="date" placeholder="结束日期" style="width: 150px;" v-model="GetReportRecordList.params.endTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-select placeholder="是否解决" v-model="GetReportRecordList.params.flag" clearable="true" style="width: 100px; margin-left: 15px">
          <el-option :value="true" label="是"></el-option>
          <el-option :value="false" label="否"></el-option>
        </el-select>
        <el-button type="primary" style="margin-top: 40px; margin-left: 20px;" icon="el-icon-search" @click="getReportRecordList(2)">查询</el-button>
        <el-button type="info" style="margin-top: 40px; margin-left: 20px;" @click="reset">重置</el-button>
      </div>
      <el-table style="margin-top: 20px; font-size: 14px;" :data="reportRecordList.result.reportRecordList"
                @sort-change='sort_change' v-loading="isLoading">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="报修内容">
                <span>{{ props.row.reportContent }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="_id" prop="_id" v-if="false"></el-table-column>
        <el-table-column label="id" prop="alarmPointId" v-if="false"></el-table-column>
        <el-table-column label="报修标题" prop="reportTitle" width="150"></el-table-column>
        <el-table-column label="报修警报点" prop="pointName" width="150"></el-table-column>
        <el-table-column label="报修人姓名" prop="reporterName" width="150"></el-table-column>
        <!--<el-table-column label="所属区域" prop="areaId" width="150"></el-table-column>-->
        <el-table-column label="是否解决" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.flag ? 'success':'error'">
              {{scope.row.flag ? '是':'否'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="报修时间" prop="reportTime" width="180" sortable></el-table-column>
        <el-table-column label="异常类型" prop="reportType" width="150"></el-table-column>
        <!--<el-table-column label="报修内容" prop="reportContent" width="auto"></el-table-column>-->
        <el-table-column label="操作" width="300" align="center" fixed="right">
          <template slot-scope="scope">
            <!--<el-button type="text" @click="alarmPointView">查看警报点信息</el-button>-->
            <el-button type="text" icon="el-icon-suitcase-1" @click="gotoRepair(scope.row)" :disabled="scope.row.flag">维修</el-button>
            <el-button type="text" icon="el-icon-document" @click="getRepairRecordList(scope.row._id)">维修记录</el-button>
            <el-button type="text" icon="el-icon-edit" @click="openUpdateReportRecordDialog(scope.row)">编辑</el-button>
            <el-button type="text" @click="openDeleteReportRecordDialog(scope.row)" icon="el-icon-delete" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="addButton">
        <el-button type="primary" size="medium" @click="openAddReportRecordDialog">添加报修记录</el-button>
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="getReportRecordList(1)"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="cycleTotalCount*10"
          :current-page.sync=" GetReportRecordList.params.pageNumber">
        </el-pagination>
      </div>
      <el-dialog :visible.sync="repairListDialogVisible" @close="getReportRecordList()" v-if="repairListDialogVisible">
        <el-table style="font-size: 14px;" :data="repairRecordList.result.repairRecordList">
          <!--<el-table-column type="index"></el-table-column>-->
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="维修内容">
                  <span>{{ props.row.repairContent }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="关联报修记录" prop="reportTitle" width="150"></el-table-column>
          <el-table-column label="维修警报点" prop="pointName" width="150"></el-table-column>
          <el-table-column label="维修人姓名" prop="repairerName" width="150"></el-table-column>
          <!--<el-table-column label="所属区域" prop="areaId" width="150"></el-table-column>-->
          <el-table-column label="是否解决" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.flag ? 'success':'error'">
                {{scope.row.flag ? '是':'否'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="维修时间" prop="repairTime" width="150"></el-table-column>
          <el-table-column label="维修内容" prop="repairContent" width="auto"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="getRepairRecordList(this.choosenReportRecordId)"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="totalCount1*10"
          :current-page.sync="GetRepairRecordList.params.pageNumber">
        </el-pagination>
      </el-dialog>
    </el-card>
    <AddReportRecord :add-report-record-dialog-visible="addReportRecordDialogVisible" @feedBack="getAddReportRecordFeedBack"></AddReportRecord>
    <UpdateReportRecord :update-report-record-dialog-visible="updateReportRecordDialogVisible" :alt-report-record="AltReportRecord" @feedBack="getUpdateReportRecordFeedBack"></UpdateReportRecord>
    <RepairListDialog :repair-list-dialog-visible="repairListDialogVisible" :repair-record-list="repairRecordList" @feedBack="getRepairListDialogFeedBack"></RepairListDialog>
    <AddRepairRecord :add-repair-record-dialog-visible="addRepairRecordDialogVisible" :report-record-id="choosenReportRecordId" :alarm-point-id="choosenAlarmPointId"
                     :point-name="choosenPointName" @feedBack="getAddRepairRecordFeedBack"></AddRepairRecord>
  </div>
</template>

<script>
  import AddReportRecord from './addReportRecord'
  import UpdateReportRecord from './UpdateReportRecord'
  import RepairListDialog from './RepairListDialog'
  import AddRepairRecord from '../RepairRecord/AddRepairRecord'
  export default {
    name: 'ReportRecord',
    components: { AddRepairRecord, RepairListDialog, UpdateReportRecord, AddReportRecord },
    data(){
      return {
        isLoading: true,
        addRepairRecordDialogVisible: false,
        choosenReportRecordId:"",
        choosenAlarmPointId:"",
        repairListDialogVisible: false,
        currentPage:1,
        totalCount1:"",
        cycleTotalCount:'',
        addReportRecordDialogVisible: false,// 添加报修记录模态框显示与否
        updateReportRecordDialogVisible:false,// 修改报修记录模态框显示与否
        labelPosition:'left',
        // 获得报修记录列表
        GetReportRecordList:{
          "version": 1,
          "method": "report.GetReportRecordList",
          "params": {
            "pointName":null,
            "reporterName":null,
            "startTime":null,
            "endTime":null,
            "flag":null,
            "pageNumber":1
          },
          "token": "",
          "id": 0
        },
        // 报修记录列表
        reportRecordList:{
          "version": 1,
          "result":{
            "reportRecordList": [
              {
                "reportRecordId":"",
                "alarmPointId": "",
                "reporterId": "",
                "reportTime": "",
                "reportContent": "",
                "flag":""
                // "repairRecordIdList":[1,2,3,..]
              },
            ]
          },
          "id": 0
        },
        DeleteReportRecord:{
          "version": 1,
          "method": "report.DeleteReportRecord",
          "params":{
            "reportRecordId":""
          },
          "token": "#",
          "id": 0
        },

        // 修改报修记录
        AltReportRecord:{
          "version": 1,
          "method": "report.AltReportRecord",
          "params": {
            "reportRecordId":"",
            "reportTime": "",
            "reportContent":"",
          },
          "token": "#",
          "id": 0
        },
        // 获取警报点列表
        GetAlarmPointList:{
          "version": 1,
          "method": "alarmpoint.GetAlarmPointList",
          "params": {
            "pointName":null,
            "alarmPointType":null,
            "areaId":null
          },
          "token": "#",
          "id": 0
        },
        // 警报点列表
        alarmPointList:{
          "version": 1,
          "result":{
            "alarmPointList": [
              {
                "alarmPointId":  "",
                "pointName": "",
                "alarmPointType": "",
                "longitude": "",
                "latitude": "",
                "alarmRadius":"",
                "areaId":"",
                "installAt":"",
                "remark":""
              },
            ]
          },
          "id": 0
        },
        // 获取用户列表
        GetUserList:{
          "version": 1,
          "method": "user.GetUserList",
          "params": {
            "username":"",
            "name":"",
            "role":""
          },
          "token": "",
          "id": 0
        },
        // 账户列表
        userList:{
          "version": 1,
          "result":{
            "userList":[],
          },
          "id": 0
        },

        // 获取维修记录列表
        GetRepairRecordList:{
          "version": 1,
          "method": "repair.GetRepairRecordList",
          "params": {
            "pageNumber":1,
            "reportRecordId": "",
            // "repairRecordId":"",
            "alarmPointId":"",
            "repairerName":"",
            "startTime":"",
            "endTime":"",
            "flag":""
          },
          "token": "#",
          "id": 0
        },
        // 维修列表
        repairRecordList:{
          "version": 1,
          "result":{
            "repairRecordList": [
              {
                "reportRecordId":"#",
                "repairRecordId":"#",
                "alarmPointId": "#",
                "repairerName": "#",
                "areaId": "#",
                "repairTime": "#",
                "repairContent": "#",
                "flag":"#"
              },
              {
                "reportRecordId":"#",
                "repairRecordId":"#",
                "alarmPointId": "#",
                "repairerName": "#",
                "areaId": "#",
                "repairTime": "#",
                "repairContent": "#",
                "flag":"#"
              },
            ]
          },
          "id": 0
        },
      }
    },
    methods: {
      my_desc_sort(a, b) {
        if (a.reportTime > b.reportTime) {
          return -1
        } else if (a.reportTime < b.reportTime) {
          return 1
        } else {
          return 0
        }
      },
      my_asc_sort(a, b) {
        if (a.reportTime > b.reportTime) {
          return 1
        } else if (a.reportTime < b.reportTime) {
          return -1
        } else {
          return 0
        }
      },
      sort_change(column){
        this.currentPage = 1 // return to the first page after sorting
        if (column.order === 'descending') {
          this.reportRecordList.result.reportRecordList = this.reportRecordList.result.reportRecordList.sort(this.my_desc_sort)
        } else if (column.order === 'ascending') {
          this.reportRecordList.result.reportRecordList = this.reportRecordList.result.reportRecordList.sort(this.my_asc_sort)
        }
      },
      getAddRepairRecordFeedBack(addRepairRecordDialogVisible){
        this.addRepairRecordDialogVisible = addRepairRecordDialogVisible;
        this.getReportRecordList(1);
      },
      gotoRepair(row){
        this.choosenReportRecordId = row._id;
        this.choosenAlarmPointId = row.alarmPointId;
        this.choosenPointName = row.pointName;
        this.addRepairRecordDialogVisible = true;
      },
      handleCurrentChange(currentPage){
        this.currentPage = currentPage;
      },
      // 获取报修记录
      getReportRecordList(val){
        this.isLoading = true;
        for(let key in this.GetReportRecordList.params){
          if(this.GetReportRecordList.params[key] === ""){
            this.GetReportRecordList.params[key] = null;
          }
        }
        if(val == 2){
          this.GetReportRecordList.params.pageNumber = 1;
        }
        this.GetReportRecordList.token = this.$store.state.token;
        console.log('获取报修记录请求');
        console.log(this.GetReportRecordList);
        this.$axios.post(this.$mainUrl, this.GetReportRecordList).then(res=>{
          this.isLoading = false;
          console.log('获取报修记录请求得到响应')
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.reportRecordList = res.data;
            this.reportRecordList.result.reportRecordList.reverse();
            this.cycleTotalCount = res.data.result.page;//获取规划表数据总数
          }else{
            this.$message({
              type: 'error',
              message: '获取报修记录失败，' + res.data.error.message
            })
          }
        })
      },
      openAddReportRecordDialog(){
        // 打开添加报修记录模态框
        this.addReportRecordDialogVisible = true;
      },
      openUpdateReportRecordDialog(row){
        for(let key in this.AltReportRecord.params){
          this.AltReportRecord.params[key] = row[key];
        }
        this.AltReportRecord.params.reportRecordId = row._id;
        console.log(this.AltReportRecord);
        this.updateReportRecordDialogVisible = true;
      },
      openDeleteReportRecordDialog(row){
        this.DeleteReportRecord.token = this.$store.state.token;
        this.DeleteReportRecord.params.reportRecordId = row._id;
        console.log('删除报修记录请求');
        console.log(this.DeleteReportRecord);
        this.$confirm('此操作将删除该报修记录，是否继续', '提示', {
          confirmButtonText:'删除',
          cancelButtonText:'取消',
          type:'warning'
        }).then(()=>{
          this.$axios.post(this.$mainUrl, this.DeleteReportRecord).then(res=>{
            console.log('删除报修记录请求获得响应');
            console.log(res.data);
            if(res.data.hasOwnProperty('result')){
              this.$message({
                type:'success',
                message: '删除成功'
              })
              this.getReportRecordList(1);
            }else{
              this.$message({
                type: 'error',
                message: "删除失败，" + res.data.error.message
              })
            }
          })
        }).catch(()=>{
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      getAddReportRecordFeedBack(addReportRecordDialogVisible){
        this.addReportRecordDialogVisible = addReportRecordDialogVisible;
        this.getReportRecordList(1);
      },
      getUpdateReportRecordFeedBack(updateReportRecordDialogVisible){
        this.updateReportRecordDialogVisible = updateReportRecordDialogVisible;
        this.getReportRecordList(1);
      },
      getRepairListDialogFeedBack(repairListDialogVisible){
        console.log('haha');
        this.repairListDialogVisible = repairListDialogVisible;
      },
      // 获取用户列表
      getUserList(){
        for(let key in this.GetUserList.params){
          if(this.GetUserList.params[key] === ""){
            this.GetUserList.params[key] = null;
          }
        }
        this.GetUserList.token = this.$store.state.token;
        console.log('获取用户列表请求');
        console.log(this.GetUserList);
        this.$axios.post(this.$mainUrl, this.GetUserList).then(res =>{
          console.log('获取用户列表请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.userList = res.data;
            this.userList.result.userList.reverse();
          }else{
            this.$message({
              type:'error',
              message:'获取用户列表失败，' + res.data.error.message
            })
          }
        })
      },
      // 获取警报点列表
      getAlarmPointList(){
        for (let val in this.GetAlarmPointList.params){
          if(this.GetAlarmPointList.params[val] === ""){
            this.GetAlarmPointList.params[val] = null;
          }
        }
        this.GetAlarmPointList.token = this.$store.state.token;
        console.log('获取警报点列表请求');
        console.log(this.GetAlarmPointList);
        this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
          console.log('获取警报点列表请求得到响应');
          console.log(res.data);
          this.alarmPointList = res.data;
          this.alarmPointList.result.alarmPointList.reverse();
        })
      },
      // 获取维修记录
      getRepairRecordList(row){
        this.choosenReportRecordId = row;
        this.repairListDialogVisible = true;
        for(let key in this.GetRepairRecordList.params){
          if(this.GetRepairRecordList.params[key] === ""){
            this.GetRepairRecordList.params[key] = null;
          }
        }
        this.GetRepairRecordList.token = this.$store.state.token;
        //this.GetRepairRecordList.params.alarmPointId = row.alarmPointId
        this.GetRepairRecordList.params.reportRecordId = this.choosenReportRecordId;
        console.log('获取维修记录请求');
        console.log(this.GetRepairRecordList);
        this.$axios.post(this.$mainUrl, this.GetRepairRecordList).then(res=>{
          console.log('获取维修记录请求得到响应')
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.repairRecordList = res.data;
            this.totalCount1 = res.data.result.page;
            this.repairRecordList.result.repairRecordList.reverse();
          }else{
            this.$message({
              type: 'error',
              message: '获取维修记录失败，' + res.data.error.message
            })
          }
        })
      },
      reset(){
        this.GetReportRecordList.params.alarmPointId = ''
        this.GetReportRecordList.params.reporterName = '';
        this.GetReportRecordList.params.startTime = '';
        this.GetReportRecordList.params.endTime = ''
        this.GetReportRecordList.params.flag = ''
      }
    },
    mounted(){
      this.getReportRecordList(1);
    }
  }
</script>

<style scoped>
  .handle_input{
    width: 200px;
    height: 16px;
    margin-left: 20px;
    display: inline-block;

  }
  .handle_select{
    width: 120px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_date_picker{
    width: 120px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_box{
    margin-top: -30px;
  }
  .addButton{
    text-align: left;
    margin-top: 20px;
    position: relative;
    float: left;
  }
  .pagination{
    position: relative;
    float: right;
    margin-top: 20px;
    text-align: right;
  }
</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>

